import React, { FC } from 'react'
import { Button, Col } from 'antd'
import { RNavigatorRow } from './styles'

type Props = {
  displayNext?: boolean
  displaySubmit?: boolean
  displayBack?: boolean
  onNext?: () => void
  onBack?: () => void
  onSubmit?: () => void
}

const RNavigator: FC<Props> = ({
  displayNext = true,
  displayBack = true,
  displaySubmit = false,
  onNext,
  onBack,
  onSubmit,
}) => {
  return (
    <RNavigatorRow>
      {displayBack && (
        <Col className='pr-24'>
          <Button size='large' onClick={onBack}>
            {'< Back'}
          </Button>
        </Col>
      )}
      {displayNext && (
        <Col>
          <Button type='primary' size='large' onClick={onNext}>
            {'Next >'}
          </Button>
        </Col>
      )}
      {displaySubmit && (
        <Col>
          <Button type='primary' size='large' onClick={onSubmit}>
            {'Submit'}
          </Button>
        </Col>
      )}
    </RNavigatorRow>
  )
}

export default RNavigator
